module.exports = __webpack_public_path__ + "assets/img/1.aaa5435e.jpg";